interface OliveIconProps {
  className?: string;
  /** Color del trazo (hojas y tallo). Default cream. */
  color?: string;
  /** Color de la aceituna. Default verde claro. */
  oliveColor?: string;
}

/**
 * Ícono de rama de olivo — marca ANIMAstore.
 * Pensado para ir dentro de un contenedor con fondo (ej. cuadrado verde oliva).
 */
export default function OliveIcon({ className, color = '#F2EDDF', oliveColor = '#9AA868' }: OliveIconProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* tallo */}
      <path d="M9 24 C 13 18, 17 12, 22 8" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      {/* hojas */}
      <g fill={color}>
        <ellipse cx="13.5" cy="18.5" rx="3.2" ry="1.5" transform="rotate(-35 13.5 18.5)" />
        <ellipse cx="17.5" cy="14" rx="3.2" ry="1.5" transform="rotate(-35 17.5 14)" />
        <ellipse cx="20" cy="20" rx="3.2" ry="1.5" transform="rotate(20 20 20)" />
        <ellipse cx="21.5" cy="9.5" rx="3" ry="1.4" transform="rotate(-35 21.5 9.5)" />
      </g>
      {/* aceituna */}
      <circle cx="22" cy="22.5" r="2.1" fill={oliveColor} />
    </svg>
  );
}
